import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import EngineApp from "@/components/EngineApp";
import LandingPage from "@/components/LandingPage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/mvp" element={<EngineApp />} />
      </Routes>
    </BrowserRouter>
  );
}
